//#region Config
const PROTOCOL_RE = /^[a-z]+:\/\//i;
//#endregion

/**
 * This is not a security utility! It's a connivent utility to generate valid
 * URLs for common cases
 */
export function escapedUrl(urlFragments: TemplateStringsArray, ...items: Array<string | number>) {
  let result = "";
  let hasProtocol = false;

  let i = 0;
  for (; i < items.length; i++) {
    result += urlFragments[i];

    if (!hasProtocol && PROTOCOL_RE.test(result)) {
      hasProtocol = true;
    }

    const item = String(items[i]);
    result += hasProtocol ? encodeURIComponent(item) : item;

    if (__DEV__ && hasProtocol && item.includes("/")) {
      throw new Error("escapedUrl(): Template literals expression cannot contain slashes '/'");
    }
  }

  result += urlFragments[i];

  if (__DEV__ && !PROTOCOL_RE.test(result)) {
    throw new Error(`escapedUrl(): Received URL without a protocol of '${result}'`);
  }

  return result;
}
